function getUserDataState(state) {
  return {
    userData: state.userData.userData,
    isLoading: state.userData.loading,
    fetched: state.userData.fetched,
    fetchError: state.userData.fetchUserDataError,
    success: state.userData.success,
    updateError: state.userData.updateUserDataError
  };
}

export { getUserDataState };
